import {merge} from '#core/utils/config-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateBetBaseInfo} from '#core/application/modules/tiles/bet-base-info/index.js';

import BET_LEGS_INFO from './bet-legs-info.palette-schema.yaml';

registerTileSchema(BET_LEGS_INFO);

export function generateBetLegsInfo(TILE) {
    const LEGS_BASE_INFO = generateBetBaseInfo(TILE.LEGS_BASE_INFO);

    return {
        priceBoostIndicator: LEGS_BASE_INFO.priceBoostValue,
        startingPriceIndicator: LEGS_BASE_INFO.startingPriceIndicator,
        bestOddsIcon: LEGS_BASE_INFO.bestOddsIcon,
        selectionName: {
            style: LEGS_BASE_INFO.selectionName,
        },
        marketName: {
            style: LEGS_BASE_INFO.marketName,
        },
        eventName: {
            style: LEGS_BASE_INFO.eventName,
        },
        eventStartDateTimeText: {
            style: {
                ...LEGS_BASE_INFO.date,
            },
        },
        // matchAcca
        matchAccaSelectionItem: LEGS_BASE_INFO.betBuilderSelectionItem,
        matchAccaHeaderText: {
            style: LEGS_BASE_INFO.betBuilderSelectionName,
        },
        matchAccaEventName: {
            style: LEGS_BASE_INFO.betBuilderMarketName,
        },
        // odds
        oddsLabel: {
            style: LEGS_BASE_INFO.odds,
        },
        oddsBoostIndicator: {
            bonusIndicator: merge(LEGS_BASE_INFO.betBonusIndicator, {
                container: {
                    style: {
                        padding: '0 0 4px',
                    },
                },
            }),
        },
        earlyPayoutIndicator: merge(LEGS_BASE_INFO.earlyPayoutIndicator, {
            container: {
                style: {
                    padding: '0 0 4px',
                },
            },
        }),
        legDateInfoText: {
            style: {
                ...TILE.LEG_DATE_INFO_TEXT,
            },
        },
        voidReasonMessage: merge(LEGS_BASE_INFO.voidReasonNotification, {
            notification: {
                icon: {
                    src: 'semantic-info',
                },
            },
        }),
    };
}
